import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';

// Standardized input matching limit/stop loss styling across app
const FormInput = ({
  value,
  onChange,
  onBlur,
  type = 'text',
  min,
  max,
  step,
  placeholder,
  style = {},
  disabled = false,
  ...rest
}) => {
  const { colors } = useTheme();
  
  return (
    <input
      type={type}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      min={min}
      max={max}
      step={step}
      placeholder={placeholder}
      disabled={disabled}
      {...rest}
      style={{
        backgroundColor: colors.bgInput,
        border: `1px solid ${colors.border}`,
        color: colors.text,
        borderRadius: 6,
        padding: '6px 8px',
        height: 30,
        lineHeight: '18px',
        fontSize: 12,
        ...style
      }}
    />
  );
};

export default FormInput;


